// extracted by mini-css-extract-plugin
export {};
    if(module.hot) {
      // 1678451809644
      var cssReload = require("../../../next-ui-library/node_modules/.pnpm/mini-css-extract-plugin@2.7.3_webpack@5.76.0/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  